app.service('accountCartRetrieve', function (modal, loading, log, localStorage) {

	function saveMessage(message){
		localStorage.setItem('afterReloadMessage', message);
	}
	function action(action, cart) {
		loading.start();
		log.event({ id: 'laczenie-koszykow', f03: action });
		$.ajax({
			url: '/merge-carts.ltr',
			type: 'POST',
			data: {
				action: action,
				previousCartCookie: cart
			},
			success: function (json) {
				if (json.status === 'SUCCESS') {
					if(action == 'MERGE'){
						saveMessage(`<h2>Produkty zostały dodane do koszyka</h2>`);
					} else if(action == 'OVERRIDE_LAST'){
						saveMessage(`<h2>Wcześniejszy koszyk został usunięty</h2>`);
					} else if(action == 'OVERRIDE_CURRENT'){
						saveMessage(`<h2>Koszyk został przywrócony</h2>`);
					}
					loading.redirect('/cart.bhtml');
				} else {
					modal.alert('Błąd łączenia koszyków. Spróbuj ponownie');
				}
			},
			error: function () {
				modal.alert('Błąd w komunikacji łączenia koszyków. Spróbuj ponownie');
			}
		})
	}

	return {
		action
	};
});